var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgM(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 24C47 37.2548 36.4787 48 23.5 48C10.5213 48 0 37.2548 0 24C0 10.7452 10.5213 0 23.5 0C36.4787 0 47 10.7452 47 24Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_926_68)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8276 12.1458C36.0162 11.6523 35.8973 11.094 35.5235 10.7204C35.15 10.3469 34.5918 10.2278 34.0983 10.4165L6.77687 20.8629C6.26804 21.0575 5.92775 21.5408 5.9162 22.0855C5.90464 22.6301 6.22412 23.1275 6.72424 23.3434L18.022 28.222L22.9006 39.5198C23.1166 40.02 23.614 40.3395 24.1586 40.3279C24.7032 40.3163 25.1866 39.9761 25.3811 39.4671L35.8276 12.1458ZM18.4724 25.4988L10.8081 22.1893L32.2553 13.9889L24.0548 35.436L20.7452 27.7717L26.0702 22.4467C26.6978 21.8191 26.6978 20.8015 26.0702 20.1739C25.4425 19.5462 24.425 19.5462 23.7973 20.1739L18.4724 25.4988Z",
    fill: "#E9540D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_926_68"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(5.91589 10.3281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM);
export default __webpack_public_path__ + "static/media/m.7cd131aa7e62a882d0363780680263c7.svg";
export { ForwardRef as ReactComponent };